import React, { useState, useEffect } from "react";
import { FaArrowLeft, FaFileExcel } from "react-icons/fa";
import NavBar from "../components/NavMenu";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const DetailAttendance = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAttendanceLoading, setIsAttendanceLoading] = useState(true);

  const passedQuarters = location.state?.selectedQuarters || [
    "Q1 2025",
    "Q4 2024",
  ];
  const [selectedQuarters] = useState(passedQuarters);
  const [studentData, setStudentData] = useState([]);
  const [studentCount, setStudentCount] = useState(0);
  const [courseCodes, setCourseCodes] = useState([]);
  const [selectedCourseCode, setSelectedCourseCode] = useState("");
  const [sortConfig, setSortConfig] = useState({
    key: "att_rate",
    direction: "desc",
  });

  const parseQuarterYear = (quarterStr) => {
    const [qtr, year] = quarterStr.split(" ");
    return {
      qtr: parseInt(qtr.replace("Q", "")),
      year: parseInt(year),
    };
  };

  useEffect(() => {
    const fetchCourseCodes = async () => {
      try {
        const { qtr, year } = parseQuarterYear(selectedQuarters[0]);
        const res = await axios.get(
          `${process.env.REACT_APP_API}/getAttendanceByStudent?qtr=${qtr}&year=${year}`
        );
        const allCourses =
          res.data.current?.map((item) => item.course_code) || [];
        const uniqueCourses = [...new Set(allCourses)];
        setCourseCodes(uniqueCourses);
      } catch (err) {
        console.error("Failed to fetch course codes", err);
      }
    };

    fetchCourseCodes();
  }, [selectedQuarters]);

  useEffect(() => {
    const fetchData = async () => {
      setIsAttendanceLoading(true);
      const { qtr, year } = parseQuarterYear(selectedQuarters[0]);

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}/getAttendanceByStudent?qtr=${qtr}&year=${year}&courseCode=${selectedCourseCode}`
        );

        const current = res.data.current || [];
        setStudentData(current);
        setStudentCount(current.length);
      } catch (err) {
        console.error("Failed to fetch student data", err);
      } finally {
        setIsAttendanceLoading(false);
      }
    };

    fetchData();
  }, [selectedQuarters, selectedCourseCode]);

  const handlePrevious = () => {
    const passedQuarters = location.state?.selectedQuarters || [
      "Q1 2025",
      "Q4 2024",
    ];
    const extractedQuarter = parseInt(
      passedQuarters[0].split(" ")[0].replace("Q", "")
    );
    const extractedYear = parseInt(passedQuarters[0].split(" ")[1]);

    navigate("/home", {
      state: {
        view: "attendance",
        selectedQuarter: extractedQuarter,
        selectedYear: extractedYear,
      },
    });
  };

  const handleSort = () => {
    let direction = "asc";
    if (sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: "att_rate", direction });
  };

  const sortedData = [...studentData].sort((a, b) => {
    let valA = a.att_rate;
    let valB = b.att_rate;
    if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
    if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  return (
    <>
      <NavBar />
      <div style={containerStyle}>
        <div style={headerStyle}>
          <div style={leftHeader}>
            <FaArrowLeft size={18} onClick={handlePrevious} />
            <h4 style={{ margin: 0 }}>Attendance Details</h4>
            <span style={chipStyle}>{selectedQuarters[0]}</span>
            <span style={chipStyle}>Total Count: {studentCount}</span>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <select
              value={selectedCourseCode}
              onChange={(e) => setSelectedCourseCode(e.target.value)}
              style={{
                padding: "6px 12px",
                borderRadius: 6,
                background: "#000",
                color: "#fff",
              }}
            >
              <option value="">All Courses</option>
              {courseCodes.map((code, i) => (
                <option key={i} value={code}>
                  {code}
                </option>
              ))}
            </select>

            <button
              onClick={() => console.log("Export to Excel")}
              className="excel-button"
            >
              <FaFileExcel size={18} /> Export to Excel
            </button>
          </div>
        </div>

        <div style={{ overflowX: "auto", borderRadius: 6 }}>
          {isAttendanceLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 220,
              }}
            >
              <div className="spinner" />
            </div>
          ) : (
            <table style={tableStyle}>
              <thead style={{ backgroundColor: "#000" }}>
                <tr>
                  <th style={{ ...thStyle, width: "5%" }}>NO.</th>
                  <th style={{ ...thStyle, width: "15%" }}>STUDENT ID</th>
                  <th style={{ ...thStyle, width: "25%" }}>NAME</th>
                  <th style={{ ...thStyle, width: "25%" }}>COURSE CODE</th>
                  <th
                    style={{ ...thStyle, cursor: "pointer" }}
                    onClick={handleSort}
                  >
                    ATTENDANCE RATE (%){" "}
                    {sortConfig.direction === "asc" ? "▲" : "▼"}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((row, i) => (
                  <tr
                    key={i}
                    style={{
                      backgroundColor: i % 2 === 0 ? "#2b2b2b" : "#252525",
                    }}
                  >
                    <td style={{ ...tdStyle, width: "5%" }}>{i + 1}</td>
                    <td style={{ ...tdStyle, width: "15%" }}>
                      {row.student_id}
                    </td>
                    <td style={{ ...tdStyle, width: "25%" }}>{row.name}</td>
                    <td style={{ ...tdStyle, width: "25%" }}>
                      {row.course_code}
                    </td>
                    <td style={{ ...tdStyle, width: "30%", minWidth: 120 }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <div
                          style={{
                            height: 8,
                            width: "100%",
                            backgroundColor: "#444",
                            borderRadius: 6,
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{
                              width: `${row.att_rate}%`,
                              height: "100%",
                              backgroundColor:
                                row.att_rate >= 80 ? "#4caf50" : "#ff9800",
                            }}
                          />
                        </div>
                        <span
                          style={{ fontSize: 12, color: "#fff", minWidth: 30 }}
                        >
                          {row.att_rate}%
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
};

const containerStyle = {
  backgroundColor: "#373636",
  margin: 20,
  borderRadius: 10,
  padding: 30,
  minHeight: "calc(100vh - 80px)",
  color: "#fff",
};

const headerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: 20,
  flexWrap: "wrap",
  gap: 12,
};

const leftHeader = { display: "flex", alignItems: "center", gap: 12 };

const chipStyle = {
  background: "#444",
  padding: "6px 12px",
  borderRadius: 8,
  fontSize: 14,
  fontWeight: 500,
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  backgroundColor: "#1f1f1f",
  borderRadius: 6,
  overflow: "hidden",
};

const thStyle = {
  padding: "14px 12px",
  textAlign: "left",
  fontWeight: "bold",
  fontSize: 15,
  color: "#fff",
  borderBottom: "1px solid #444",
};

const tdStyle = {
  padding: "12px 12px",
  color: "#ddd",
  fontSize: 14,
};

export default DetailAttendance;
